/**
 * Locale-aware formatting for the Portal UI. Components pass the locale from
 * useLocale(); nothing here reads global state.
 */
import { scheduleToEn } from '../utils/cronToEn';
import { scheduleToZh } from '../utils/cronToZh';
import { formatDateTime } from '../utils/formatDate';
import { htmlLangFor } from './locale';
import type { Locale } from './resources';

export { formatDateTime };

/** Format a number with the locale's grouping and decimal rules, e.g. 1234.5 -> "1,234.5". */
export function formatNumber(value: number, locale: Locale, options?: Intl.NumberFormatOptions): string {
  return new Intl.NumberFormat(htmlLangFor(locale), options).format(value);
}

/** Describe an EventBridge schedule (cron / at / rate) in the locale, in UTC+8. */
export function describeSchedule(expr: string, locale: Locale): string {
  return locale === 'en' ? scheduleToEn(expr) : scheduleToZh(expr);
}
